export default {"src":"/_next/static/media/spice.2cdd45a0.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};